"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _utils = require("../utils");
var _iphoneX = require("../mixins/iphone-x");
var _getContainer = require("../mixins/get-container");
var _icon = _interopRequireDefault(require("../icon"));
var _use = (0, _utils.use)('button-group'),
  sfc = _use[0],
  bem = _use[1];
var _default = sfc({
  mixins: [_iphoneX.iPhoneXMixin, _getContainer.GetContainerMixin],
  props: {
    keepPosition: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    absolute: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default' // options: publish
    },

    topStyle: {
      type: String,
      default: '' // options: hairline
    },

    publishText: {
      type: String,
      default: '发布'
    },
    insideCard: Boolean
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  },
  data: function data() {
    return {
      height: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.height = _this.$refs['button-group'].offsetHeight;
    });
  },
  render: function render(h) {
    var keepPosition = this.keepPosition,
      isiPhoneX = this.isiPhoneX,
      fixed = this.fixed,
      type = this.type,
      publishText = this.publishText,
      insideCard = this.insideCard,
      absolute = this.absolute;
    var ButtonGroup = h("div", {
      "ref": 'button-group',
      "class": [bem(), type, fixed ? 'fixed' : '', absolute ? 'absolute' : '', isiPhoneX && (fixed || absolute) ? 'z-iphone-x' : '']
    }, [this.slots('header'), type === 'publish' ? h("div", {
      "class": bem('publish'),
      "on": {
        "click": this.onClick
      }
    }, [h(_icon.default, {
      "attrs": {
        "name": "6824b935-d36f-4a8a-8851-480e4c7b2840.png"
      }
    }), h("span", [publishText])]) : h("div", {
      "class": bem('default', {
        shadow: this.topStyle === 'shadow',
        hairline: this.topStyle === 'hairline',
        inside: insideCard
      })
    }, [this.slots('left'), this.slots()])]);
    return keepPosition ? h("div", {
      "style": {
        position: 'relative',
        height: this.height + 'px'
      }
    }, [ButtonGroup]) : ButtonGroup;
  }
});
exports.default = _default;